// extracted by mini-css-extract-plugin
export default {"chatsList":"BusinessChatHistory_chatsList__mal4Y","header":"BusinessChatHistory_header__PnqCO","isError":"BusinessChatHistory_isError__n-QD+"};